<template>
  <div class="top flex-between flex-y-center">
    <div class="flex-y-center">
      <img
        @click="routeHop('/')"
        class="imgs"
        :src="initProjectList.site_info.logo"
        alt=""
      />
      <img
        @click="routeHop('/')"
        class="imgt"
        src="../assets/images/fgline.png"
        alt=""
      />
      <div class="imgs logo-r" @click="routeHop('/')">
        中共江西省委党校研究生报名系统
      </div>
    </div>
    <div class="flex-end" v-show="userInfo.id > 0">
      <div class="flex-1 notice iconfont icon-tongzhi" @click="toNotice">
        <div class="noctice-text">通知</div>
      </div>
      <div
        class="flex-1 off iconfont icon-fanhui"
        @click="routeHop('/project')"
      >
        <div class="noctice-text">
          <span style="margin-left: -18px">返回主界面</span>
        </div>
      </div>
      <div class="turn-back iconfont icon-tuichu" @click="loginOut()">
        <div class="noctice-text">
          <span style="margin-left: -7px"> 退出登录</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "pinia";
import { useMainStore } from "@/store/piniaStore";
import { stopIdleTimer } from "@/utils/idleTimeout";
export default {
  computed: {
    ...mapState(useMainStore, {
      initProjectList: "getInitProject",
      userInfo: "getUserInfo",
    }),
  },
  mounted() {
    console.log(this.userInfo);
  },
  methods: {
    ...mapActions(useMainStore, [
      "logout"
    ]),
    routeHop(url) {
      this.$router.push(url);
    },
    toNotice() {
      this.$router.push("/notice");
    },
    //退出登录
    loginOut() {
      stopIdleTimer();
      this.logout();
      this.$router.push("/login");
    },
  },
};
</script>

<style>
.turn-back {
  color: #b8000d;
  font-size: 26px;
  font-weight: 600;
}
.noctice-text {
  font-size: 10px;
  width: 70px;
  font-weight: 350;
}
.notice:hover {
  cursor: pointer;
}
.notice {
  color: #b8000d;
  font-weight: 600;
  font-size: 26px;
}
.off:hover {
  cursor: pointer;
}
.off {
  color: #b8000d;
  font-size: 26px;
  font-weight: 600;
}
.top {
  margin-left: 10%;
  width: 80%;
  margin-top: 30px;
}
/* .imgs:hover{
  cursor: pointer;
} */
.imgs {
  width: 300px;
}
.imgt {
  margin: 0px 30px;
  opacity: 0.2;
}

.logo-r {
  font-size: 20px;
  font-weight: bold;
  margin: 10px 0;
  color: rgb(167, 165, 165);
}
</style>
